import { render } from "./MultipleTrailerSelection.vue?vue&type=template&id=517c908c&scoped=true&ts=true"
import script from "./MultipleTrailerSelection.vue?vue&type=script&lang=ts"
export * from "./MultipleTrailerSelection.vue?vue&type=script&lang=ts"

import "./MultipleTrailerSelection.vue?vue&type=style&index=0&id=517c908c&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-517c908c"]])

export default __exports__